import React from 'react';
import { GripVertical, User, Layers } from 'lucide-react';
import { getStatusStyle } from './calendarUtils';
import { ShiftPeriodBadgeForShift } from './ShiftPeriodBadge';

// Compact shift card used inside week / month grids.
// Pure UI — receives shift + handlers as props.
export function CalendarShiftCard({ shift, onClick, compact, draggable, onDragStart }) {
  const style = getStatusStyle(shift.status);
  const isShared = shift.support_ratio === '1:2' && (shift.linked_participants || []).filter(Boolean).length >= 2;
  return (
    <div
      className={`rounded-md border px-2 py-1.5 cursor-pointer transition-all hover:shadow-md ${style.bg} mb-1 ${draggable ? 'active:opacity-60' : ''}`}
      onClick={() => onClick(shift)}
      draggable={draggable}
      onDragStart={onDragStart ? (e) => onDragStart(e, shift) : undefined}
      data-testid={`shift-card-${shift.id}`}
    >
      <div className="flex items-center gap-1.5 mb-0.5">
        {draggable && <GripVertical className="w-2.5 h-2.5 text-slate-400 flex-shrink-0 cursor-grab" />}
        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${style.dot}`} />
        <span className={`text-[11px] font-semibold truncate ${style.text}`}>{shift.start_time}–{shift.end_time}</span>
        {isShared && (
          <span
            className="ml-auto inline-flex items-center gap-0.5 text-[9px] font-semibold text-violet-700 bg-violet-100 border border-violet-200 rounded px-1 py-0"
            title={`Shared Support — 1 worker, ${(shift.linked_participants || []).length} participants`}
            data-testid="shared-support-badge"
          >
            <Layers className="w-2.5 h-2.5" />
            1:{(shift.linked_participants || []).length}
          </span>
        )}
      </div>
      <div className="mb-0.5"><ShiftPeriodBadgeForShift shift={shift} /></div>
      {!compact && (
        <>
          <p className="text-[10px] font-medium truncate text-slate-800">{shift.participant_name || 'Unassigned'}</p>
          <p className="text-[10px] truncate text-slate-500">{shift.service_name || ''}</p>
          {shift.assigned_staff?.length > 0 && (
            <div className="flex items-center gap-1 mt-0.5">
              <User className="w-2.5 h-2.5 text-slate-400" />
              <span className="text-[9px] text-slate-500 truncate">{shift.assigned_staff.map(s => s.name).join(', ')}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}

